export const itemVariants = {
  openMenu: { y: 0, opacity: 1, transition: { type: 'spring', damping: 8, mass: 0.5 } },
  closeMenu: { y: '-100%', opacity: 0 },
};
